import React from 'react';
import { motion } from 'framer-motion';
import './Skills.css';

const LanguagesTools = () => {
  const skills = [
    { name: 'C++', url: 'https://www.w3schools.com/cpp/', img: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/cplusplus/cplusplus-original.svg' },
    { name: 'Python', url: 'https://www.python.org', img: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg' },
    { name: 'JavaScript', url: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript', img: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg' },
    { name: 'React', url: 'https://reactjs.org/', img: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg' },
    { name: 'Swift', url: 'https://developer.apple.com/swift/', img: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/swift/swift-original.svg' },
    { name: 'HTML5', url: 'https://www.w3.org/html/', img: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original-wordmark.svg' },
    { name: 'CSS3', url: 'https://www.w3schools.com/css/', img: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original-wordmark.svg' },
    { name: 'Express', url: 'https://expressjs.com', img: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/express/express-original-wordmark.svg' },
    { name: 'Firebase', url: 'https://firebase.google.com/', img: 'https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg' },
    { name: 'MongoDB', url: 'https://www.mongodb.com/', img: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg' },
    { name: 'MySQL', url: 'https://www.mysql.com/', img: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg' },
    { name: 'PostgreSQL', url: 'https://www.postgresql.org', img: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/postgresql/postgresql-original-wordmark.svg' },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.5 },
    visible: { opacity: 1, scale: 1, transition: { type: "spring", bounce: 0.4, duration: 0.8 } }
  };

  return (
    <section className="skills-section">
      <div className="section-header">
        <h2 className="section-title">Languages and Tools</h2>
      </div>
      <motion.div 
        className="skills-grid"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-50px" }}
        style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '2.5rem', maxWidth: '1000px', margin: '0 auto' }}
      >
        {skills.map((skill, index) => (
          <motion.a 
            key={index}
            href={skill.url} 
            target="_blank" 
            rel="noreferrer" 
            className="skill-item glass"
            variants={itemVariants}
            whileHover={{ scale: 1.15, y: -5, boxShadow: "var(--shadow-glow)" }}
            whileTap={{ scale: 0.95 }}
            style={{ width: '110px', height: '110px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1.5rem', borderRadius: '24px', position: 'relative' }}
          >
            <img
              src={skill.img}
              alt={skill.name}
              className="skill-icon"
              style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            />
          </motion.a>
        ))}
      </motion.div>
    </section>
  );
};

export default LanguagesTools;

